import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { StyledRelativeWrapper, StyledTabsWrapper, StyledFlex } from './BorderControlRequirement.styles';
import TrainOutboundIcon from './Icons/TrainOutboundIcon';
import { getStationDetails } from './BordercontrolRequirements.utils';
import TrainReturnIcon from './Icons/TrainReturnIcon';

export const BordercontrolRequirementsTabs = ({ from, to, allStations, outbound = true }) => (
  <StyledRelativeWrapper>
    <StyledTabsWrapper>
      {outbound ? (
        <>
          <TrainOutboundIcon />
          <FormattedMessage id="journeySummary.outbound" />
        </>
      ) : (
        <>
          <TrainReturnIcon />
          <FormattedMessage id="journeySummary.inbound" />
        </>
      )}
    </StyledTabsWrapper>
    <StyledFlex>
      ( {getStationDetails({ station: outbound ? from : to, stations: allStations, includeCity: true })?.shortName}{' '}
      <FormattedMessage id="extras.to" />{' '}
      {getStationDetails({ station: outbound ? to : from, stations: allStations, includeCity: true })?.shortName} )
    </StyledFlex>
  </StyledRelativeWrapper>
);

BordercontrolRequirementsTabs.propTypes = {
  outbound: PropTypes.bool,
  from: PropTypes.string,
  to: PropTypes.string,
  allStations: PropTypes.array
};
